import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ScifinderStatus } from './retrosynthesis-types';

const c = initContract();
const pathPrefix = '/internal-retrosynthesis';

export const retrosynthesisContract = c.router(
  {
    createSynthesisLink: {
      method: 'GET',
      path: '/create/:searchId/:resultId',
      pathParams: z.object({
        searchId: z.string(),
        resultId: z.string(),
      }),
      headers: z.object({
        authorization: z.string(),
      }),
      responses: {
        200: z
          .object({
            retroScoreToken: z.string(),
          })
          .optional(),
      },
    },
    fetchStatus: {
      method: 'GET',
      path: '/status/:searchId/:resultId',
      pathParams: z.object({
        searchId: z.string(),
        resultId: z.string(),
      }),
      headers: z.object({
        authorization: z.string(),
      }),
      responses: {
        200: z.object({
          link: z.string().optional(),
          status: z.nativeEnum(ScifinderStatus),
        }),
      },
    },
    fetchSearchGraph: {
      method: 'GET',
      path: '/search-graph/:searchId/:resultId',
      pathParams: z.object({
        searchId: z.string(),
        resultId: z.string(),
      }),
      responses: {
        200: z.unknown(),
      },
    },
    fetchHypertree: {
      method: 'GET',
      path: '/hypertree/:searchId/:resultId',
      pathParams: z.object({
        searchId: z.string(),
        resultId: z.string(),
      }),
      responses: {
        200: z.unknown(),
      },
    },
    fetchSearchConfig: {
      method: 'GET',
      path: '/search-config/:searchId/:resultId',
      pathParams: z.object({
        searchId: z.string(),
        resultId: z.string(),
      }),
      responses: {
        200: c.otherResponse({ contentType: 'text/plain', body: z.string() }),
      },
    },
  },
  {
    pathPrefix,
  }
);
